module.exports = __webpack_public_path__ + "static/media/icon_bacode_W.05c882f3.svg";